const COUNTRY_CODES = Object.freeze({
  'United Kingdom': 'gb', 'United States': 'us', Netherlands: 'nl', Belgium: 'be',
  Sweden: 'se', Spain: 'es', France: 'fr', Italy: 'it', Germany: 'de', Greece: 'gr', Portugal: 'pt',
});

export const standardPackTelemetrySku = (kind, data, duration, country, authoritativeCountryCode) => {
  const countryCode = String(authoritativeCountryCode || COUNTRY_CODES[country] || '').toLowerCase();
  const durationDays = Number.parseInt(String(duration), 10);
  const dataToken = String(data || '').trim().toLowerCase();
  if (!['travel', 'privacy'].includes(kind) || !/^[a-z]{2}$/.test(countryCode) || !/^\d+gb$/.test(dataToken) || !durationDays) return '';
  return `${kind}-${dataToken}-${durationDays}-${countryCode}`;
};

export const unlimitedTelemetrySku = (title, region) => {
  const countryCode = COUNTRY_CODES[region];
  if (!countryCode) return '';
  return String(title).includes('+ VPN') ? `unlimited-vpn-30-${countryCode}` : `unlimited-data-30-${countryCode}`;
};

export const virtualNumberTelemetrySku = (country) => (
  country === 'UK' ? 'gb-virtual-number-30' : country === 'USA' ? 'us-virtual-number-30' : ''
);
